module.exports = __webpack_public_path__ + "img/related-intro.33176c18.png";